import React from 'react'
import { BillingUtils } from '@front/volcanion/utils'
import { IconUtils } from '@front/squirtle/utils'

import { TableCell, Icon, Chip, Tooltip } from '@mui/material'

const Payment = ({ row }) => {
  const rawTotal = BillingUtils.getPaymentDisplay(row?.job?.payment, true, 1)
  const total = `${parseFloat(rawTotal)}€`
  const paymentMethodIcon = IconUtils.getPaymentMethodIcon(row?.payment_type?.erp_code)

  return (
    <TableCell padding='none'>
      <Tooltip title={`${row?.payment_type?.name} - ${total}`}>
        <Chip
          label={`- ${total}`}
          color='primary'
          size='small'
          align='center'
          sx={{ px: 1 }}
          icon={<Icon color='primary' fontSize={'small'}>{paymentMethodIcon}</Icon>}
        />
      </Tooltip>
    </TableCell>
  )
}

export default React.memo(Payment)
